<template>
  <div v-if="$store.getters.calendar" class="calender" :style="styleOption">
    <div>
      <ul class="calenderMonth">
        <li @click="leftHandler">&lt;</li>
        <li>
          <span>{{year}}</span>
          <span>{{month}}</span>
        </li>
        <li @click="rightHandler">&gt;</li>
      </ul>
    </div>
    <div class="calenderDay">
      <ul>
        <li>일</li>
        <li>월</li>
        <li>화</li>
        <li>수</li>
        <li>목</li>
        <li>금</li>
        <li>토</li>
      </ul>
      <ul v-for="days in daysList" :key="days.index">
        <li v-for="day in days" :key="day.date">
          <span :class="[day.class, day.color]" @click="dayHandler(day.time)" :title="day.title">{{day.date}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data: function () {
    return {
      date: null,
      year: null,
      month: null,
      daysList: null
    }
  },
  created () {},
  name: 'ucalendar',
  watch: {
    '$store.getters.calendar': 'open'
  },
  computed: {
    calendar () {
      return this.$store.getters.calendar
    },
    styleOption: function () {
      if (this.calendar) {
        console.log(this.calendar)
        var ys = 220
        return {
          left: Math.min(this.calendar.x, window.innerWidth - 225) + 'px',
          top: ((this.calendar.y + ys > window.innerHeight) ? this.calendar.y - ys - this.calendar.h : this.calendar.y) + 'px'
        }
        // return {
        //   left: this.calendar.x + 'px',
        //   top: this.calendar.y + 'px'
        // }
      } else {
        return {
          left: '0px',
          top: '0px'
        }
      }
    }
  },
  methods: {
    open () {
      if (this.calendar) {
        this.$root.$el.addEventListener('mouseup', this.mouseUp)
        this.date = new Date(this.calendar.date.getTime())
        this.year = this.calendar.date.getFullYear()
        this.month = this.calendar.date.getMonth() + 1
        this.renderCalendar()
      }
    },
    leftHandler () {
      this.date.setMonth(this.date.getMonth() - 1)
      this.renderCalendar()
    },
    rightHandler () {
      this.date.setMonth(this.date.getMonth() + 1)
      this.renderCalendar()
    },
    getColor (day, hd, date) {
      var i
      for (i = 0; i < hd.length; i++) {
        if (hd[i].locdate === Number('' + this.year + this.getMonth() + this.getDate(date))) {
          return {color: 'red', title: hd.splice(i, 1)[0].dateName}
        }
      }
      switch (day) {
        case 0 :
          return {color: 'red', title: ''}
        case 6 :
          return {color: 'blue', title: ''}
        default :
          if (this.calendar.date.getFullYear() === this.year && this.calendar.date.getMonth() + 1 === this.month && this.calendar.date.getDate() === date) {
            return {color: 'gray', title: ''}
          } else {
            return {color: '', title: ''}
          }
      }
    },
    getMonth () {
      switch (this.month.toString().length) {
        case 1 :
          return '0' + this.month
        default :
          return this.month
      }
    },
    getDate (date) {
      switch (date.toString().length) {
        case 1 :
          return '0' + date
        default :
          return date
      }
    },
    renderCalendar () {
      this.year = this.date.getFullYear()
      this.month = this.date.getMonth() + 1
      this.drawCalender([])
      this.$http.get('/ets/getRestDeInfo?ServiceKey=5qNFyXywQQIR3irw4UaVHmzuuZWxg4ysbmWXTcjX5MSLz6Cm0ZBo6ThZU6WJLNSivUlwMkHTKKSkVVvVSXPSdA%3D%3D', {
        params: {
          solYear: this.year,
          solMonth: this.getMonth()
        }}).then((response) => {
        console.log(response)
        var hd = response.response.body.items.item !== undefined ? [].concat(response.response.body.items.item) : []
        console.log(hd)
        this.drawCalender(hd)
      }).catch((e) => {
      })
    },
    dayHandler (e) {
      if (this.calendar.callback != null) {
        this.calendar.callback(e)
      }
      this.$store.commit('calendar', null)
      this.$root.$el.removeEventListener('mouseup', this.mouseUp)
    },
    mouseUp (e) {
      if (!this.isTarget(e, this.$el)) {
        console.log('calendar')
        this.$store.commit('calendar', null)
        this.$root.$el.removeEventListener('mouseup', this.mouseUp)
      } else {
        console.log('calendar out')
      }
    },
    drawCalender (hd) {
      var vd = new Date(this.date)
      vd.setDate(1)
      vd.setDate(1 - vd.getDay())
      var li = []
      var i, k, c
      for (i = 0; i < 6; i++) {
        li[i] = []
        for (k = 0; k < 7; k++) {
          c = this.getColor(vd.getDay(), hd, vd.getDate())
          li[i][k] = {
            date: vd.getDate(),
            time: vd.getTime(),
            color: c.color,
            title: c.title,
            class: this.date.getMonth() !== vd.getMonth() ? 'calenderDayPrev' : ''
          }
          vd.setDate(vd.getDate() + 1)
        }
      }
      this.daysList = li
    }
  }
}
</script>

<style scoped>
.calender {
  z-index: 110;
  position: absolute;
  border: solid 1px #999999;
  cursor:auto;

}
.calender ul {
  list-style: none;
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 0;
  width: 100%;
}
.calenderMonth {
  padding: 10px 0px 10px 0px;
}
.calenderMonth li {
  width: 34%;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.calenderMonth li:first-child {
  cursor:pointer;
}
.calenderMonth li:last-child {
  cursor:pointer;
}
.calenderMonth li span:first-child {
  font-size: 16px;
}
.calenderMonth li span:last-child {
  font-size: 36px;
}
.calender div:first-child {
  background-color: #667788;
  color: #FFFFFF;
}
.calenderDay {
  background-color: #FFFFFF;
  padding: 10px 5px 10px 5px;
}
.calenderDayPrev {
  opacity: 0.3;
}
.red {
  color: red;
}
.blue {
  color: blue;
}
.gray {
  background-color: var(--disable);
}
.calenderDay li {
  width: 30px;
  height: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calenderDay li span {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calenderDay ul:nth-child(1n+2) li:hover{
  background-color: #999999;
  color: #FFFFFF;
}
.calenderDay ul:nth-child(1n+2) {
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Ucalendar.vue